
import { useRef } from "react";
import "./App.scss";
import { LiveAPIProvider } from "./contexts/LiveAPIContext";
import { Altair } from "./components/altair/Altair";
import ControlTray from "./components/control-tray/ControlTray";
// import cn from "classnames";
import AvatarWrapper from "./components/avatar/AvatarWrapper";
import Clarity from '@microsoft/clarity';

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY as string;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_APIK_KEY in .env");
}

const host = "generativelanguage.googleapis.com";
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`;
const clarity_project_id = "ppii1vgpol"

function App() {
  // const [isConsoleVisible, setConsoleVisible] = useState(false);
  // const [selectedFunction, setSelectedFunction] = useState("All");
  const videoRef = useRef<HTMLVideoElement>(null);
  // const [videoStream, setVideoStream] = useState<MediaStream | null>(null);
  Clarity.init(clarity_project_id);

  return (
    <div className="App">
      <LiveAPIProvider url={uri} apiKey={API_KEY}>
        <div className="streaming-console">
          {/* <SidePanel /> */}
          <main>
            <div className="main-app-area">
              <AvatarWrapper />
              <Altair />
              {/* <video
                className={cn("stream", {
                  hidden: !videoRef.current || !videoStream,
                })}
                ref={videoRef}
                autoPlay
                playsInline
              /> */}
            <ControlTray
              videoRef={videoRef}
              supportsVideo={false}
              // onVideoStreamChange={setVideoStream}
            >
              {/* put your own buttons here */}
            </ControlTray>
            </div>

          </main>
        </div>
      </LiveAPIProvider>
    </div>
  );
}

export default App;
